export default __webpack_public_path__ + "static/HarmoniaSansProCyr-Regular-30c52a948de89d7589c7e63ff93e1bcc.woff";